import { Link, useLocation } from 'react-router-dom';
import menus from '../menu';

function HeaderModern(props) {
    const location = useLocation();

    // Helper function to check if a menu item should be active
    const isActive = (menuItem) => {
        // Exact match
        if (location.pathname === menuItem.linkmenu) return true;

        // Dynamic routes - check if pathname starts with the base path
        if (menuItem.linkmenu === '/services-v1' && location.pathname.startsWith('/services/')) return true;
        if (menuItem.linkmenu === '/blog' && location.pathname.startsWith('/blog/')) return true;
        if (menuItem.linkmenu === '/about-v1' && location.pathname.startsWith('/team/')) return true;

        // Check if props.data.names matches (from page header)
        if (props.data && props.data.names && menuItem.name === props.data.names) return true;

        return false;
    };

        return (
            <div id="header" className="header bg-color style2 v1">
                <div className="container">
                    <div className="row">
                        <div className="header-wrap">
                            <div className="col-md-12">
                                <div className="flat-header-wrap">
                                    <div className="nav-wrap">
                                        <div className="btn-menu">
                                            <span></span>
                                        </div>
                                        {/* <!-- //mobile menu button --> */}
                                        <nav id="mainnav" className="mainnav">
                                            <ul className="menu">
                                            {
                                                menus.map(data =>(
                                                    <li className={isActive(data) ? "active" : ""} key={data.id}>
                                                        <Link to={data.linkmenu}>{data.name}</Link>
                                                        {
                                                            data.namesub === undefined ? "" :
                                                            <ul className="sub-menu">
                                                                {
                                                                    data.namesub.map(submenus =>(
                                                                        <li className={location.pathname === submenus.links || submenus.sub === props.data.names02 ? "active" : ""} key={submenus.id}><Link to={submenus.links}>{submenus.sub}</Link>
                                                                            {
                                                                                submenus.submenu === undefined ? "" :
                                                                                <ul className="sub-menu">
                                                                                    {
                                                                                        submenus.submenu.map(menusub => (
                                                                                            <li className={location.pathname === menusub.linksub ? "active" : ""} key={menusub.id}><Link to= {menusub.linksub}>{menusub.titlesub}</Link></li>
                                                                                        ))
                                                                                    }
                                                                                </ul>
                                                                            }
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        }
                                                    </li>
                                                ))
                                            }
                                            </ul>
                                            {/* <!-- /.menu --> */}
                                        </nav>
                                        {/* <!-- /#mainnav --> */}
                                    </div>
                                    {/* <!-- /.nav-wrap --> */}
                                    <div className="flat-show-search">
                                        <div className="show-search">
                                            <Link to="#"><i className="fa fa-search"></i></Link>
                                        </div>
                                        <div className="top-search">
                                            <form action="#" id="searchform-all" method="get">
                                                <div>
                                                    <input type="text" id="s" className="sss" placeholder="Search..." />
                                                    <input type="submit" value="" id="searchsubmit" />
                                                </div>
                                            </form>
                                        </div>
                                        {/* <!-- /.top-search --> */}
                                    </div>
                                    {/* <!-- /.flat-show-search --> */}
                                </div>
                            </div>
                            {/* <!-- /.col-md-12 --> */}
                        </div>
                        {/* <!-- /.header-wrap --> */}
                    </div>
                    {/* <!-- /.row --> */}
                </div>
                {/* <!-- /.container --> */}
            </div>
            /* <!-- /header style2 --> */
        );
}

export default HeaderModern;